import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';

const LaporanGamifikasi = () => {
  const [loading, setLoading] = useState(false);
  const [statistics, setStatistics] = useState(null);
  const [leaderboard, setLeaderboard] = useState([]);
  const [periode, setPeriode] = useState('all');
  const [showPrintPreview, setShowPrintPreview] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || `${process.env.REACT_APP_API_URL}`;
  const getToken = () => localStorage.getItem('token');

  // Fetch data saat component mount atau periode berubah
  useEffect(() => {
    fetchData();
  }, [periode]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = getToken();
      
      // Fetch statistics
      const statsResponse = await axios.get(`${API_URL}/gamification/statistics`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Fetch leaderboard
      const leaderboardResponse = await axios.get(`${API_URL}/gamification/leaderboard`, {
        params: { limit: 100, period: periode },
        headers: { Authorization: `Bearer ${token}` }
      });

      if (statsResponse.data.success) {
        setStatistics(statsResponse.data.statistics);
      }
      
      if (leaderboardResponse.data.success) {
        setLeaderboard(leaderboardResponse.data.leaderboard);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      alert('Gagal memuat data laporan');
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const exportToCSV = () => {
    const headers = ['Peringkat', 'Kode Anggota', 'Nama', 'Kelas', 'Level', 'Total EXP', 'Total Peminjaman', 'Pengembalian Tepat Waktu'];
    const data = leaderboard.map(user => [
      user.rank,
      user.kode_anggota,
      user.nama_lengkap,
      user.kelas || '-',
      user.level,
      user.total_exp,
      user.total_peminjaman,
      user.pengembalian_tepat_waktu
    ]);

    let csvContent = headers.join(',') + '\n';
    data.forEach(row => {
      csvContent += row.join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `laporan-gamifikasi-${periode}-${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
  };

  const getLevelName = (level) => {
    const levels = {
      1: 'Book Novice',
      2: 'Word Explorer',
      3: 'Page Conqueror',
      4: 'The Scholar',
      5: 'Guardian of Knowledge'
    };
    return levels[level] || '-';
  };

  const getPeriodeName = (period) => {
    const periods = {
      'all': 'Semua Waktu',
      'monthly': 'Bulan Ini',
      'weekly': 'Minggu Ini'
    };
    return periods[period] || 'Semua Waktu';
  };

  if (loading) {
    return (
      <Layout>
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid rgba(60, 141, 188, 0.2)',
            borderTop: '4px solid #3C8DBC',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }}></div>
          <style>
            {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
          </style>
          <p style={{ marginTop: '1rem', color: '#6c757d' }}>Memuat data laporan...</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <style>
        {`
          @media print {
            .no-print {
              display: none !important;
            }
            body {
              background: white;
            }
            .print-area {
              padding: 20px;
            }
          }
        `}
      </style>

      <div className="print-area" style={{ padding: '1.5rem' }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #3C8DBC 0%, #2c6c91 100%)',
          borderRadius: '12px',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          color: '#FFFFFF',
          boxShadow: '0 4px 15px rgba(60, 141, 188, 0.3)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
            <span style={{ fontSize: '2.5rem' }}>📊</span>
            <h2 style={{ margin: 0, fontSize: '1.75rem', fontWeight: 'bold' }}>
              Laporan Gamifikasi Perpustakaan
            </h2>
          </div>
          <p style={{ margin: 0, opacity: 0.9 }}>
            Periode: {getPeriodeName(periode)} | Tanggal Cetak: {new Date().toLocaleDateString('id-ID', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        {/* Filter & Actions - No Print */}
        <div className="no-print" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1.5rem',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {['all', 'monthly', 'weekly'].map(p => (
              <button
                key={p}
                onClick={() => setPeriode(p)}
                style={{
                  padding: '0.6rem 1.2rem',
                  borderRadius: '8px',
                  border: 'none',
                  background: periode === p ? '#3C8DBC' : '#e9ecef',
                  color: periode === p ? '#FFFFFF' : '#343A40',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                {getPeriodeName(p)}
              </button>
            ))}
          </div>

          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button
              onClick={exportToCSV}
              style={{
                padding: '0.6rem 1.2rem',
                borderRadius: '8px',
                border: 'none',
                background: '#28a745',
                color: '#FFFFFF',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            >
              📥 Export CSV
            </button>
            <button
              onClick={handlePrint}
              style={{
                padding: '0.6rem 1.2rem',
                borderRadius: '8px',
                border: 'none',
                background: '#3C8DBC',
                color: '#FFFFFF',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            >
              🖨️ Cetak Laporan
            </button>
          </div>
        </div>

        {/* Statistics Cards */}
        {statistics && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '1rem',
            marginBottom: '2rem'
          }}>
            <div style={{
              background: '#FFFFFF',
              border: '2px solid #e9ecef',
              borderRadius: '12px',
              padding: '1.5rem',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              <p style={{ color: '#6c757d', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                👥 Total Anggota Aktif
              </p>
              <p style={{ color: '#3C8DBC', fontSize: '2rem', fontWeight: 'bold', margin: 0 }}>
                {statistics.total_users}
              </p>
            </div>

            <div style={{
              background: '#FFFFFF',
              border: '2px solid #e9ecef',
              borderRadius: '12px',
              padding: '1.5rem',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              <p style={{ color: '#6c757d', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                📊 Rata-rata EXP
              </p>
              <p style={{ color: '#3C8DBC', fontSize: '2rem', fontWeight: 'bold', margin: 0 }}>
                {Math.round(statistics.avg_exp)}
              </p>
            </div>

            <div style={{
              background: '#FFFFFF',
              border: '2px solid #e9ecef',
              borderRadius: '12px',
              padding: '1.5rem',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              <p style={{ color: '#6c757d', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                🏆 EXP Tertinggi
              </p>
              <p style={{ color: '#3C8DBC', fontSize: '2rem', fontWeight: 'bold', margin: 0 }}>
                {statistics.highest_exp}
              </p>
            </div>

            <div style={{
              background: '#FFFFFF',
              border: '2px solid #e9ecef',
              borderRadius: '12px',
              padding: '1.5rem',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              <p style={{ color: '#6c757d', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                👑 Guardian of Knowledge
              </p>
              <p style={{ color: '#3C8DBC', fontSize: '2rem', fontWeight: 'bold', margin: 0 }}>
                {statistics.level_5_count}
              </p>
            </div>
          </div>
        )}

        {/* Level Distribution */}
        {statistics && (
          <div style={{
            background: '#FFFFFF',
            border: '2px solid #e9ecef',
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '2rem',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{ color: '#343A40', marginBottom: '1rem', fontSize: '1.25rem' }}>
              📈 Distribusi Level Anggota
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1rem' }}>
              {[
                { level: 1, name: 'Book Novice', count: statistics.level_1_count },
                { level: 2, name: 'Word Explorer', count: statistics.level_2_count },
                { level: 3, name: 'Page Conqueror', count: statistics.level_3_count },
                { level: 4, name: 'The Scholar', count: statistics.level_4_count },
                { level: 5, name: 'Guardian', count: statistics.level_5_count }
              ].map(item => (
                <div key={item.level} style={{
                  background: '#f8f9fa',
                  padding: '1rem',
                  borderRadius: '8px',
                  textAlign: 'center',
                  border: '2px solid #e9ecef'
                }}>
                  <p style={{ color: '#6c757d', fontSize: '0.8rem', marginBottom: '0.25rem' }}>
                    Level {item.level}
                  </p>
                  <p style={{ color: '#343A40', fontSize: '0.85rem', marginBottom: '0.5rem', fontWeight: '500' }}>
                    {item.name}
                  </p>
                  <p style={{ color: '#3C8DBC', fontSize: '1.5rem', fontWeight: 'bold', margin: 0 }}>
                    {item.count}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Top 10 Peminjam */}
        <div style={{
          background: '#FFFFFF',
          border: '2px solid #e9ecef',
          borderRadius: '12px',
          padding: '1.5rem',
          marginBottom: '2rem',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ color: '#343A40', marginBottom: '1rem', fontSize: '1.25rem' }}>
            🏆 Top 10 Peminjam Aktif
          </h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '0.9rem'
            }}>
              <thead>
                <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #e9ecef' }}>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>#</th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', color: '#343A40' }}>Kode</th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', color: '#343A40' }}>Nama</th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', color: '#343A40' }}>Kelas</th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>Total Peminjaman</th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>Tepat Waktu</th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>Level</th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>Total EXP</th>
                </tr>
              </thead>
              <tbody>
                {leaderboard.slice(0, 10).map((user, index) => (
                  <tr key={user.id_anggota} style={{
                    borderBottom: '1px solid #e9ecef',
                    background: index < 3 ? 'rgba(60, 141, 188, 0.05)' : 'transparent'
                  }}>
                    <td style={{ 
                      padding: '0.75rem', 
                      textAlign: 'center',
                      fontWeight: 'bold',
                      color: index < 3 ? '#3C8DBC' : '#343A40',
                      fontSize: index < 3 ? '1.1rem' : '0.9rem'
                    }}>
                      {index < 3 ? ['🥇', '🥈', '🥉'][index] : index + 1}
                    </td>
                    <td style={{ padding: '0.75rem', color: '#343A40' }}>{user.kode_anggota}</td>
                    <td style={{ padding: '0.75rem', color: '#343A40', fontWeight: '500' }}>{user.nama_lengkap}</td>
                    <td style={{ padding: '0.75rem', color: '#6c757d' }}>{user.kelas || '-'}</td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', color: '#3C8DBC', fontWeight: 'bold' }}>
                      {user.total_peminjaman}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', color: '#28a745', fontWeight: 'bold' }}>
                      {user.pengembalian_tepat_waktu}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center' }}>
                      <span style={{
                        background: '#3C8DBC',
                        color: '#FFFFFF',
                        padding: '0.25rem 0.75rem',
                        borderRadius: '50px',
                        fontSize: '0.8rem',
                        fontWeight: 'bold'
                      }}>
                        {user.level}
                      </span>
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', color: '#3C8DBC', fontWeight: 'bold' }}>
                      {user.total_exp}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Daftar Lengkap Semua Anggota */}
        <div style={{
          background: '#FFFFFF',
          border: '2px solid #e9ecef',
          borderRadius: '12px',
          padding: '1.5rem',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ color: '#343A40', marginBottom: '1rem', fontSize: '1.25rem' }}>
            📋 Daftar Lengkap Semua Anggota ({leaderboard.length} Anggota)
          </h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '0.85rem'
            }}>
              <thead>
                <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #e9ecef' }}>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>Peringkat</th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', color: '#343A40' }}>Kode</th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', color: '#343A40' }}>Nama</th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', color: '#343A40' }}>Kelas</th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>Level</th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', color: '#343A40' }}>Level Name</th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>Total EXP</th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>Peminjaman</th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>Tepat Waktu</th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>Progress</th>
                </tr>
              </thead>
              <tbody>
                {leaderboard.map((user) => (
                  <tr key={user.id_anggota} style={{ borderBottom: '1px solid #e9ecef' }}>
                    <td style={{ padding: '0.75rem', textAlign: 'center', fontWeight: 'bold', color: '#343A40' }}>
                      {user.rank}
                    </td>
                    <td style={{ padding: '0.75rem', color: '#343A40' }}>{user.kode_anggota}</td>
                    <td style={{ padding: '0.75rem', color: '#343A40' }}>{user.nama_lengkap}</td>
                    <td style={{ padding: '0.75rem', color: '#6c757d' }}>{user.kelas || '-'}</td>
                    <td style={{ padding: '0.75rem', textAlign: 'center' }}>
                      <span style={{
                        background: '#3C8DBC',
                        color: '#FFFFFF',
                        padding: '0.25rem 0.5rem',
                        borderRadius: '50px',
                        fontSize: '0.75rem',
                        fontWeight: 'bold'
                      }}>
                        {user.level}
                      </span>
                    </td>
                    <td style={{ padding: '0.75rem', color: '#343A40', fontSize: '0.8rem' }}>
                      {getLevelName(user.level)}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', color: '#3C8DBC', fontWeight: 'bold' }}>
                      {user.total_exp}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', color: '#3C8DBC' }}>
                      {user.total_peminjaman}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', color: '#28a745' }}>
                      {user.pengembalian_tepat_waktu}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', color: '#343A40' }}>
                      {Math.round(user.progress_percentage)}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer untuk Print */}
        <div style={{
          marginTop: '3rem',
          paddingTop: '1.5rem',
          borderTop: '2px solid #e9ecef',
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: '0.85rem',
          color: '#6c757d'
        }}>
          <div>
            <p style={{ margin: 0 }}>Laporan Gamifikasi Perpustakaan</p>
            <p style={{ margin: 0 }}>SMPN 4 Tilatang Kamang</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p style={{ margin: 0 }}>Dicetak pada:</p>
            <p style={{ margin: 0, fontWeight: 'bold' }}>
              {new Date().toLocaleDateString('id-ID', { 
                day: 'numeric',
                month: 'long', 
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

// Dummy Layout untuk preview
const LayoutAdmin = ({ children }) => {
  return (
    <div style={{ 
      minHeight: '100vh',
      background: '#f8f9fa',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      {children}
    </div>
  );
};

export default LaporanGamifikasi;